import {
  THREADS_PATHS,
  buildThreadControllerGetThreadsPath,
  buildThreadControllerGetThreadsLastActivityPath,
  buildThreadsThreadControllerGetUnreadChannelsPath,
} from '../../generated/threads/api-paths';

export const THREAD_CONTROLLER_GET_THREADS_LAST_ACTIVITY =
  THREADS_PATHS.THREAD_CONTROLLER_GET_THREADS_LAST_ACTIVITY;

export const threadsPath = buildThreadControllerGetThreadsPath;
export const threadsLastActivityPath = buildThreadControllerGetThreadsLastActivityPath;
export const threadsUnreadPath = buildThreadsThreadControllerGetUnreadChannelsPath;
